import React, { useState, useEffect, useCallback } from 'react';
import Accordion from '../../components/accordion/Accordion';
import '../../../styles/modules/waiver-reporting.less';

interface IssuesReportingCostsProps {
  onChange: (costs: { laborRate: number | null; hotelStay: number | null; perDiem: number | null }) => void;
}

const IssuesReportingCosts: React.FC<IssuesReportingCostsProps> = ({ onChange }) => {
  const [laborRate, setLaborRate] = useState<number | null>(150);
  const [hotelStay, setHotelStay] = useState<number | null>(200);
  const [perDiem, setPerDiem] = useState<number | null>(50);
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);

  useEffect(() => {
    onChange({ laborRate, hotelStay, perDiem });
  }, [laborRate, hotelStay, perDiem]);

  const handleInputChange = useCallback(
    (setter: React.Dispatch<React.SetStateAction<number | null>>) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.trim();
      if (/^\d{0,4}$/.test(value)) {
        setter(value === "" ? null : Number(value));
        setAccordionOpen(true);
      }
    },
    []
  );

  const panels = [
    {
      id: 'costsAndVariables',
      title: 'COSTS AND VARIABLES',
      show: accordionOpen,
      children: (
        <form role="form" noValidate>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <InputField
                id="labor-rate"
                label="Labor Rate ($ hr)"
                value={laborRate !== null ? laborRate : ""}
                onChange={handleInputChange(setLaborRate)}
                placeholder="Defaults to 150"
              />
              <InputField
                id="hotel-stay"
                label="Hotel Stay ($)"
                value={hotelStay !== null ? hotelStay : ""}
                onChange={handleInputChange(setHotelStay)}
                placeholder="Defaults to 200"
              />
              <InputField
                id="per-diem"
                label="Per Diem ($)"
                value={perDiem !== null ? perDiem : ""}
                onChange={handleInputChange(setPerDiem)}
                placeholder="Defaults to 50"
              />
              <div className="col-sm-6 col-md-6 col-lg-6"></div>
            </div>
          </div>
        </form>
      ),
    },
  ];

  return (
    <div className="row col-md-12 search">
      <div className="search-form">
        <Accordion id="issuesReportingCostsAccordion" className="uib-accordion" panels={panels} />
      </div>
    </div>
  );
};

interface InputFieldProps {
  id: string;
  label: string;
  value: number | string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
}

const InputField: React.FC<InputFieldProps> = ({ id, label, value, onChange, placeholder }) => (
  <div className="col-sm-2 col-md-2 col-lg-2">
    <label htmlFor={id} className="db-text">{label}</label>
    <input
      id={id}
      type="text"
      className="form-control custom-placeholder"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={4}
    />
  </div>
);

export default IssuesReportingCosts;